import React from "react";
import { Card } from "react-bootstrap";

function Mission() {
  return (
    <>
      <Card
        className="wrapper_card my-3 p-0 mission-bg shadow"
        style={{ borderRadius: 1 + "rem",}}
      ></Card>
    </>
  );
}

export default Mission;
